import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
//import Utils from '../../../custom/utils';
import {API} from "../../../../config";
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import {connect} from "react-redux";
//import AppBar from '@material-ui/core/AppBar';
//import Toolbar from '@material-ui/core/Toolbar';
//import Typography from '@material-ui/core/Typography';

//const outbound = API.service('withdrawal');
const bank_accounts = API.service('bank-accounts');
const banks = API.service('banks');
const db_utils = API.service('utils');
const investors = API.service('investors');

const moment = require('moment');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    formControl:{
      width:'100%'
    }
});

class AccountJournal extends Component {
    state={
      amount: 0,
      comment:'',
      currency:'USD',
      journal_type:'JOURNAL',
      accounts:false,
      note:'',
      from_account:1,
      to_account:1,
      reference:0,
      _timestamp:moment().format('YYYY-MM-DDTHH:MM'),
      investors:false,
    };

  fetchAllInvestors = () => {
    const app = this;

    db_utils.find().then(inv =>{
      app.props.context.update({
        investors:inv.result
      })
      console.log(this.props);
    }).catch(e=>{
      console.log('Error Loading:', e);
      app.setState({
        error:'Error: ' + e
      })
    })
  }

componentDidMount = () => {
  banks.find().then(b=>{
    console.log(b.data);
    let bankData = {};
    b.data.forEach((v,i)=>{
      bankData[v._id] = v;
    });
    console.log(bankData);
    this.setState({
      accounts:bankData
    })
  })

  investors.find({query:{$select:['_account','_firstname','_surname'],$limit:10000,$sort:{_surname:1}}}).then(i=>{
    this.setState({
      investors: i.data
    })
  })
};

    complete = () => {
        const app = this;
        let fund = parseFloat(this.state.amount);
        let creation = [];

        if(this.state.from_account !== 0) {

          if ((this.state.journal_type === 'DEBIT-JOURNAL' || this.state.journal_type === 'WITHDRAWAL-JOURNAL') && fund > 0) {
            fund = fund * -1;
          } else if ((this.state.journal_type === 'CREDIT-JOURNAL' || this.state.journal_type === 'DEPOSIT-JOURNAL') && fund < 0) {
            fund = fund * -1;
          }

          let payload =
            {
              _timestamp: this.state._timestamp,
              _bank_account: this.state.from_account,
              _fund: fund,
              _comment: this.state.comment,
              _type: this.state.journal_type,
              _reference_id: this.state.reference,
              _currency: this.state.currency,
              _user_id: this.props.user.data.email,
              _notes: this.state.note,
              _account:this.state.from_account,
              _link_account:this.state.to_account,
            };

          creation.push(payload);
        }

      if(this.state.to_account !== 0) {

        let type = this.state.journal_type;
        let to_fund = fund;

        if (this.state.from_account === 0 && (type === 'CREDIT-JOURNAL' || type === 'DEPOSIT-JOURNAL') && to_fund < 0) {
          to_fund = to_fund * -1;
        } else if(this.state.from_account !== 0) {
          if(type === 'DEBIT-JOURNAL'){
            type = 'CREDIT-JOURNAL'
          } else if(type === 'WITHDRAWAL-JOURNAL'){
            type = 'DEPOSIT-JOURNAL'
          } else if(type === 'CREDIT-JOURNAL'){
            type = 'DEBIT-JOURNAL'
          } else if(type === 'DEPOSIT-JOURNAL'){
            type = 'WITHDRAWAL-JOURNAL'
          }

          to_fund = to_fund * -1;
        }

        let to_payload =
          {
            _timestamp: this.state._timestamp,
            _bank_account: this.state.to_account,
            _fund: to_fund,
            _comment: this.state.comment,
            _type: type,
            _reference_id: this.state.reference,
            _currency: this.state.currency,
            _user_id: this.props.user.data.email,
            _notes: this.state.note,
            _account:this.state.to_account,
            _link_account:this.state.from_account,
          };

          creation.push(to_payload);
      }

        bank_accounts.create(creation).then(w=>{
          if(_.size(w) === 2){
            bank_accounts.patch(w[0].id,{_link_record:w[1].id},{query:{id:w[0].id}}).then(u=>{
              bank_accounts.patch(w[1].id,{_link_record:w[0].id},{query:{id:w[1].id}}).then(u=>{
                console.log('linked');
              })
            })
          }
          app.props.context.update({
              popupContent: false,
              updateRecords: true,
          });
        });
    };

    handleChange = (event) => {
      console.log(event.target.name,event.target.value);
        this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    }

    close = () =>{
        this.props.context.update({
            popupContent: false,
        })
    };

    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
              <div style={{padding:10}}>

                <br />

                <FormControl className={classes.formControl}>
                  <TextField
                    id="_timestamp"
                    name="_timestamp"
                    label="Journal Date & Time"
                    type="datetime-local"
                    className={classes.textField}
                    value={this.state._timestamp}
                    onChange={this.handleChange}
                    margin="normal"
                    defaultValue={moment().format('YYYY-MM-DDTHH:MM')}
                  />
                </FormControl>
                {this.state.accounts &&
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="age-simple">From</InputLabel>


                  <Select
                    value={this.state.from_account}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'from_account',
                      id: 'from_account',
                    }}
                  >
                    <MenuItem value={0}>External ({this.state.accounts[this.props.currentAccount].currency})</MenuItem>
                    {
                      //this.state.accounts.map((v, i) => {
                      Object.keys(this.state.accounts).map((key) => {
                        console.log(key);
                        if(this.state.to_account !== key) {
                          return (
                            <MenuItem
                              value={key}>{this.state.accounts[key].beneficiary_account_number} {this.state.accounts[key].type} ({this.state.accounts[key].currency})</MenuItem>
                          )
                        } else {
                          return (<React.Fragment>&nbsp;</React.Fragment>)
                        }
                      })
                    }
                  </Select>
                </FormControl>
                }
                {this.state.accounts &&
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="age-simple">To</InputLabel>


                  <Select
                    value={this.state.to_account}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'to_account',
                      id: 'to_account',
                    }}
                  >
                    <MenuItem value={0}>External ({this.state.accounts[this.props.currentAccount].currency})</MenuItem>
                    {
                      //this.state.accounts.map((v, i) => {
                      Object.keys(this.state.accounts).map((key) => {
                        if(this.state.from_account !== key) {
                          return (
                            <MenuItem
                              value={key}>{this.state.accounts[key].beneficiary_account_number} {this.state.accounts[key].type} ({this.state.accounts[key].currency})</MenuItem>
                          )
                        } else {
                          return (<React.Fragment>&nbsp;</React.Fragment>)
                        }
                      })
                    }
                  </Select>
                </FormControl>
                }
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Journal Type</InputLabel>
                    <Select
                      value={this.state.journal_type}
                      onChange={this.handleChange}
                      inputProps={{
                          name: 'journal_type',
                          id: 'journal_type',
                      }}
                    >
                        {(this.state.from_account !== 0 && this.state.to_account !== 0) && <MenuItem value={'JOURNAL'}>JOURNAL</MenuItem> }
                        {(this.state.from_account !== 0) && <MenuItem value={'DEBIT-JOURNAL'}>DEBIT</MenuItem> }
                        {(this.state.to_account !== 0) && <MenuItem value={'CREDIT-JOURNAL'}>CREDIT</MenuItem>}
                        {(this.state.to_account !== 0) && <MenuItem value={'DEPOSIT-JOURNAL'}>DEPOSIT</MenuItem>}
                        {(this.state.from_account !== 0) && <MenuItem value={'WITHDRAWAL-JOURNAL'}>WITHDRAWAL</MenuItem> }
                    </Select>
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <TextField
                    id="amount"
                    name="amount"
                    label="Amount"
                    className={classes.textField}
                    value={this.state.amount}
                    onChange={this.handleChange}
                    margin="normal"
                  />
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="age-simple">Reference Number</InputLabel>
                  {(this.state.investors) &&
                  <Select
                    value={this.state.reference}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'reference',
                      id: 'reference',
                    }}
                  >
                    <MenuItem value={0}>None</MenuItem>
                    {
                      (this.state.investors).map((key) => {
                        return (
                          <MenuItem
                            value={key._account}>{key._surname}, {key._firstname} ({key._account})</MenuItem>
                        )
                      })
                    }
                  </Select>
                  }
                  {/*<TextField
                    id="reference"
                    name="reference"
                    label="Reference Number (Investor Account)"
                    className={classes.textField}
                    value={this.state.reference}
                    onChange={this.handleChange}
                    margin="normal"
                  />*/}
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <TextField
                    id="comment"
                    name="comment"
                    label="Description"
                    className={classes.textField}
                    value={this.state.comment}
                    onChange={this.handleChange}
                    margin="normal"
                  />
                </FormControl>
                <br />
                <FormControl className={classes.formControl}>
                  <TextField
                    id="note"
                    name="note"
                    label="Notes"
                    className={classes.textField}
                    value={this.state.note}
                    onChange={this.handleChange}
                    margin="normal"
                  />
                </FormControl>
                <Button variant="contained" color="secondary" onClick={this.complete}>
                    Complete
                </Button>
                &nbsp;
                <Button variant="outlined" color="secondary" onClick={this.close}>
                    Cancel
                </Button>
              </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(AccountJournal))));
